import { Box, BottomSheet, Drawer, Form, useMediaQuery, transfersTestIds } from "@ui-kit/components/index.es";
import { bool, func, shape, string } from "prop-types";
import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as i18n from "util/i18n";
import Yup from "yup";

import { selectors as templateSelectors, actions as templateActions } from "reducers/template";

function CreateTemplateDrawerV3(props) {
    CreateTemplateDrawerV3.propTypes = {
        dispatch: func.isRequired,
        isTemplateDrawerVisible: bool.isRequired,
        values: shape({}).isRequired,
        idActivityTemplate: string.isRequired,
        idForm: string.isRequired,
        fetching: bool.isRequired,
        creatingData: shape({}).isRequired,
    };

    const { isTemplateDrawerVisible, values, fetching } = props;
    const [formikProps, setFormikProps] = useState({});
    const isMobile = useMediaQuery("min", "md");

    const parseAmount = (value) => {
        if (typeof value === "string") {
            return parseFloat(value.replaceAll(".", "").replace(",", "."));
        }
        return value;
    };

    const cleanFormValue = () => {
        if (formikProps?.resetForm) {
            formikProps.resetForm();
        }
        if (formikProps?.setValues) {
            formikProps.setValues({ templateName: "" });
        }
    };

    const handleHide = () => {
        const { dispatch } = props;
        dispatch(templateActions.closeCreateModal());
        cleanFormValue();
    };

    const handleSubmitTemplate = (templateName) => {
        const { dispatch, idForm, idActivityTemplate, creatingData } = props;
        const { concept, transferKind, amount, currency } = creatingData;
        const templateValues = {
            ...values,
            ...creatingData,
            concept: concept?.value,
            transferKind: transferKind?.value,
            amount: {
                amount: parseAmount(amount),
                currency,
            },
        };

        dispatch(
            templateActions.saveTemplate(
                idForm,
                templateValues,
                templateName,
                formikProps,
                idActivityTemplate,
                cleanFormValue,
            ),
        );
    };

    const renderForm = () => (
        <Box px={16} column gap={24} pb={24}>
            <Form
                buttonSubmit={{}}
                initialValues={{ templateName: "" }}
                inputsList={[
                    {
                        colProps: { size: { xs: 12 } },
                        component: "textFieldV3",
                        id: "templateName",
                        "data-testid": transfersTestIds.createTemplate.name,
                        label: i18n.get("transfers.template.name.v3", "Nombre de la plantilla"),
                        placeholder: i18n.get("transfers.template.name.v3", "Nombre de la plantilla"),
                        maxLength: 50,
                        variant: "dark",
                    },
                ]}
                buttonsList={[
                    {
                        colProps: { size: { xs: 12 } },
                        component: "button",
                        key: "confirm",
                        "data-testid": transfersTestIds.createTemplate.submit,
                        text: i18n.get("global.confirm"),
                        icon: "Check",
                        iconVariant: "outline",
                        variant: "solid",
                        type: "submit",
                        rounded: true,
                        withShadow: true,
                        extraInactiveCondition: () => fetching,
                        onClick: () => {},
                    },
                ]}
                onSubmit={(template) => {
                    handleSubmitTemplate(template.templateName);
                }}
                rowSpacingForm={32}
                wrapButtons
                className="w-100"
                setFormikProps={setFormikProps}
                validationSchema={Yup.object().shape({
                    templateName: Yup.string().required(i18n.get("transfers.validation.required")),
                })}
            />
        </Box>
    );

    if (isMobile) {
        return (
            <BottomSheet
                data-testid={transfersTestIds.createTemplate.drawer}
                title={i18n.get("transfers.template.title")}
                iconTitle="NewspaperAlt"
                onClose={handleHide}
                isVisible={isTemplateDrawerVisible}
                renderWithPortal>
                {renderForm()}
            </BottomSheet>
        );
    }

    return (
        <Drawer
            data-testid={transfersTestIds.createTemplate.drawer}
            keepFixedOnWeb={false}
            iconTitle="NewspaperAlt"
            onClose={handleHide}
            placement="right"
            isVisible={isTemplateDrawerVisible}
            title={i18n.get("transfers.template.title")}>
            {renderForm()}
        </Drawer>
    );
}

const mapStateToProps = (state) => ({
    isTemplateDrawerVisible: templateSelectors.isCreateModalVisible(state),
    creatingData: templateSelectors.getCreatingData(state),
    fetching: templateSelectors.isFetching(state),
});

export default withRouter(connect(mapStateToProps)(CreateTemplateDrawerV3));
